












































































































import { Component, Vue, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import { Procedimento } from '@/types/_'
import _ from 'lodash'
import EventBus from '@/plugins/EventBus'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'

@Component

export default class ComponentModalSolicitacaoCirurgiaProcedimentoAssociados extends Vue {
  procedimentoAssociadoLock: boolean = false
  inputSearch: string = ''
  loading: any = {
    searchProcedimento: false,
    listText: '',
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get getRequestMessage() {
    return this.getSolicitacaoStore.requestMessage
  }

  get getProcedimentosApi() {
    return this.getSolicitacaoStore.procedimentosApi
  }

  get getInputSearch() {
    return this.inputSearch
  }

  set getInputSearch(value) {
    this.inputSearch = value
  }

  get getShowModalProcedimento() {
    return this.getSolicitacaoStore.modalSolicitacaoCirurgia.showProcedimentoAssociado
  }

  get getProcedimentoAssociados() {
    return this.getSolicitacaoStore.solicitacao.procedimentosAssociados
  }

  @Watch('getShowModalProcedimento')
  onChangeGetShowModalProcedimento(value) {
    setTimeout(() => {
      const input = document.querySelector('.procedimento-associado-input input') as HTMLInputElement
      if (value) {
        this.getInputSearch = ''
        input.focus()
      } else {
        input.blur()
      }
    }, 100)
  }

  closeModalProcedimento() {
    this.getSolicitacaoStore.showModalProcedimentoAssociado(false)
    return this.getSolicitacaoStore.solicitacao.procedimentosAssociados
  }

  addProcedimentoQuantidade(procedimento: Procedimento) {
    if (!this.procedimentoAssociadoLock) {
      this.procedimentoAssociadoLock = true
      const p = procedimento
      p.quantidade = 1
      this.getSolicitacaoStore.setProcedimentoQuantidade(p)
      this.getSolicitacaoStore.setShowModalProcedimentoAssociadoQuantidade(true)
      this.procedimentoAssociadoLock = false
    }
  }

  async verificarCoberturaVigente(procedimento: Procedimento) {
    const { hospital } = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia
    if (!hospital.hospitalFazConsultaCoberturaVigente || hospital.tipoDeCoberturaVigente !== 'Procedimento') return

    const request = await this.getSolicitacaoCirurgiaStore.consultaCoberturaVigente(procedimento.id)
    if (request.success) this.getSolicitacaoStore.setProcedimentoAssociadoCoberturaVigente({ ...procedimento, coberturaVigente: request.data.temCoberturaVigente })
  }

  async addSelectedAssociado(procedimento: Procedimento) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.post })
    this.getSolicitacaoStore.setProcedimentoAssociado(procedimento)
    await this.verificarCoberturaVigente(procedimento)
    this.getSolicitacaoStore.removeProcedimentoApi(procedimento)
    this.loading.listText = 'Todos os itens foram selecionados.'
    EventBus.$emit('clearLoadingRequest')
  }

  async removeChip(procedimento: Procedimento) {
    this.getSolicitacaoStore.removeProcedimentoAssociado(procedimento)
    this.getSolicitacaoStore.setProcedimentoApi(procedimento)
    this.getSolicitacaoCirurgiaStore.checkNeedRejectOrRemoveProtocoloByProcedimentoAssociadoChange()
  }

  debounce = _.debounce(input => this.getSolicitacaoStore.getProcedimentoSearch(input), 600)

  search() {
    if (this.getInputSearch.length === 0 || this.getInputSearch.length > 2) {
      this.debounce(this.getInputSearch)
    }
  }
}

